<script>
  import IconClose from '@/components/atoms/IconClose'

  export default {
    name: 'ModalRegulation',
    components: {
      IconClose,
    },
    methods: {
      close() {
        this.$store.commit('toggleModalRegulation', false);
      }
    }
  }
</script>

<template lang="pug">
  transition(
    name = 'modal-regulation'
    )
    .modal-regulation(
      v-if = '$store.state.isShownModalRegulation === true'
      )
      .modal-regulation__body-wrap
        .modal-regulation__body
          .modal-regulation__close(
            @click = 'close'
            )
            IconClose(
              color = '#000'
              )
          .modal-regulation__body-row
            h2.modal-regulation__body-heading
              |参加規約
            p.modal-regulation__body-text
              |住友生命保険相互会社（以下、弊社といいます）が主催する「「Vitality日めくりクエスチョン」特設ページ」（以下、本ページといいます）にご参加いただく前に、本規約をよくお読みいただき、同意の上、ご参加ください。 本ページにご参加された場合、本規約にご同意いただいたものとみなします。 万一、本規約にご同意いただけない場合には、本ページへの参加はご遠慮ください。
            h3.modal-regulation__body-subheading
              |1.参加期間について
            p.modal-regulation__body-text
              |参加期間： 2020年02月03日（月）10時00分～2020年03月16日（月）23時59分
            h3.modal-regulation__body-subheading
              |2.Twitterアカウントや投稿内容の情報について
            ul.modal-regulation__body-list
              li 本ページ指定のハッシュタグをつけたTwitterへの投稿内容は、本ページに掲載させて頂きます。
              li さらに本ページ公式SNSアカウント上にて二次利用（写真、投稿文章、アカウントのお名前の引用）をさせて頂く場合がございます。
              li また、個人を特定しない形でのサービス向上のための統計データとして利用させて頂きます。
              li 投稿内容が、以下に該当し、または該当する恐れがあると弊社が判断した場合には、本ページに掲載しない場合があります。また掲載後であっても、予告なく本ページから掲載を取りやめる場合もございますので、予めご了承ください
                ul.modal-regulation__body-list-none
                  li ① 本規約に違反する場合。
                  li ② 公序良俗に反するもの。
                  li ③ 第三者を誹謗中傷し、またはそのプライバシーを侵害するもの。
                  li ④ 著作権、肖像権等第三者の権利を侵害するもの。法令等に違反し、または犯罪行為に結びつくもの。あるいは違法行為を助長するもの。
                  li ⑤ 画像が不鮮明なもの。
                  li ⑥ 本ページの趣旨にあわないと判断したもの。
                  li ⑦ 応募にあたって不正行為または迷惑行為を行う等、本ページの適正な運営を妨げるもの。
                  li ⑧ その他弊社が不適切と判断するもの。
              li 投稿内容について第三者との間に生じた紛争などは、投稿者の責任において当該紛争などを解決してください。
            h3.modal-regulation__body-subheading
              |3.注意事項
            ul.modal-regulation__body-list
              li 参加にはTwitterアカウントの登録（無料）が必要です。
              li 当サイトは、Twitter社とは一切関係ありません。
              li お使いいただいているパソコンの環境、また一部のスマートフォンではご参加いただけない場合がございます。
              li
                |その他の利用に関しては、弊社「
                a.modal-regulation__body-link(
                  href = "//www.sumitomolife.co.jp/fb/"
                  target = "_blank"
                  )
                  |ソーシャルメディアの利用規約
                |」をご参照ください。
      .modal-regulation__bg(
        @click = 'close'
        )
</template>

<style lang="scss">
  .modal-regulation {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2000;
    transform: translate3d(0, 0, 0);
    &__body-wrap {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      overflow-y: scroll;
      @include l-more-than-mobile {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    &__body {
      box-sizing: border-box;
      overflow: hidden;
      border-radius: 8px;
      margin: auto;
      z-index: 1;
      background-color: #fff;
      @include l-more-than-mobile {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        height: 520px;
        width: 520px;
        padding-bottom: 27px;
      }
      @include l-mobile {
        position: relative;
        width: 100%;
        max-width: 335px;
        margin-top: 20px;
        margin-bottom: 20px;
      }
    }
    &__body-row {
      height: 100%;
      overflow-y: scroll;
      @include l-more-than-mobile {
        padding-top: 27px;
        padding-right: 30px;
        padding-left: 30px;
      }
      @include l-mobile {
        padding-top: 20px;
        padding-right: 20px;
        padding-left: 20px;
        padding-bottom: 20px;
      }
    }
    &__body-heading {
      display: block;
      margin-top: 0;
      margin-right: 0;
      margin-left: 0;
      margin-bottom: 20px;
      @include fontSizeAll(20, 18);
      text-align: center;
      font-weight: bold;
    }
    &__body-subheading {
      display: block;
      margin-top: 30px;
      margin-right: 0;
      margin-left: 0;
      margin-bottom: 10px;
      @include fontSizeAll(15, 14);
      font-weight: bold;
    }
    &__body-text, &__body-list {
      display: block;
      @include fontSizeAll(15, 14);
      line-height: 1.47;
      color: #555555;
    }
    &__body-list {
      margin-left: 20px;
      line-height: 1.47;
    }
    &__body-list-none {
      margin-left: 20px;
      padding-left: 1.2em;
      list-style: none;
      text-indent: -1.2em;
    }
    &__body-link {
      color: $color-exlink;
      &:visited {
        color: $color-exlink-visited;
      }
    }
    &__close {
      width: 44px;
      height: 44px;
      cursor: pointer;
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 4px;
      right: 4px;
    }
    &__bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.7);
    }

    //
    // 表示・非表示アニメーション
    &.modal-regulation-enter-to {
      transition-duration: 0.2s;
    }
    &.modal-regulation-leave-to {
      transition-duration: 0.23s;
    }

    &__body {
      .modal-regulation-enter & {
        opacity: 0;
        transform: scale(0.9);
      }
      .modal-regulation-enter-to & {
        opacity: 1;
        transform: scale(1);
        transition-duration: 0.2s;
        transition-property: opacity, transform;
        transition-timing-function: $easeOutQuad;
      }
      .modal-regulation-leave-to & {
        opacity: 0;
        transform: scale(0.9);
        transition-duration: 0.23s;
        transition-property: opacity, transform;
        transition-timing-function: $easeInQuad;
      }
    }

    &__bg {
      .modal-regulation-enter & {
        opacity: 0;
      }
      .modal-regulation-enter-to & {
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: opacity;
      }
      .modal-regulation-leave-to & {
        opacity: 0;
        transition-duration: 0.23s;
        transition-property: opacity;
      }
    }
  }
</style>
